// extracted by mini-css-extract-plugin
export default {"parent-mode":"checkbox_parent-mode__iwIXh","button":"checkbox_button__zBr+0","checkbox":"checkbox_checkbox__Ilsfh","checkboxEmpty":"checkbox_checkboxEmpty__lzPdc"};